@if (isLoadingAccount) {
  <div>
    <h1 mat-dialog-title="" translate="">Loading account</h1>
    <mat-dialog-content class="flex justify-center items-center flex-col">
      <div class="flex flex-col w-full">
        <mat-spinner></mat-spinner>
      </div>
    </mat-dialog-content>
  </div>
}

@if (!isLoadingAccount) {
  <div>
    <div class="flex justify-between items-center flex-row">
      <h3>
        <span translate="">Account details</span>
      </h3>
      <div class="flex flex-row justify-between items-start h-full gap-[1rem]">
        @if (account && !account.verified && organization.id === 1) {
          <unite-loading-button [disabled]="account.blocked" [text]="'Resend verification email'| translate" [matStrokedButton]="true" icon="mail" [loading]="isSendingVerificationEmail" (click)="sendVerificationEmail()"></unite-loading-button>
        }
        @if (account && account.verified) {
          <unite-loading-button [disabled]="account.blocked" [text]="'Send password reset email'| translate" [matStrokedButton]="true" icon="mail" [loading]="isSendingPasswordResetEmail" (click)="sendPasswordResetEmail()"></unite-loading-button>
        }
      </div>
    </div>
    <form [formGroup]="formGroup">
      <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col w-full">
          <mat-form-field floatLabel="always">
            <mat-label translate="">Email</mat-label>
            <input matInput="" type="text" formControlName="auth0UserName" required="" autocomplete="off">
          </mat-form-field>
          <mat-checkbox labelPosition="after" class="mt1 mb2" color="primary" formControlName="blocked" fxHide="!hasAccount">
            <span class="bold" translate="">Blocked</span>
          </mat-checkbox>
          <h3 class="mt2 flex flex-row justify-start items-center w-full">
            <span translate="">Access to the following customer files</span>
          </h3>
          <unite-customer-autocomplete type="All" [label]="'Add a client' | translate" [control]="customerGroup.get('customer')"></unite-customer-autocomplete>
          <mat-table [dataSource]="customersDataSource" matSort="" matSortDisableClear="" style="width: 100%">
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[75px]">
                <mat-checkbox color="primary" (change)="$event ? masterToggle() : null" [checked]="customersSelection.hasValue() && isAllSelected()" [indeterminate]="customersSelection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let customer;" class="grow-0 shrink-0 basis-[75px]">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? customersSelection.toggle(customer) : null" [checked]="customersSelection.isSelected(customer)">
                </mat-checkbox>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef="" mat-sort-header="" class="grow-0 shrink-0 basis-[350px]">
                <span translate="">Name</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let customer;" class="grow-0 shrink-0 basis-[350px]">
                @if (customer.type == 'Person') {
                  <mat-icon class="mr1">person_outline</mat-icon>
                }
                @if (customer.type == 'Company') {
                  <mat-icon class="mr1">business_center</mat-icon>
                }
                @if (customer.type == 'Collaboration') {
                  <mat-icon class="mr1">people_outline</mat-icon>
                }
                <span>{{customer.name}}</span>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="customersDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: customersDisplayedColumns;"></mat-row>
          </mat-table>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="flex justify-between items-center">
        <button type="button" mat-button="" mat-dialog-close="">
          <span translate="">
            Cancel
          </span>
        </button>
        @if (account) {
          <unite-loading-button [text]="'Save account'| translate" (click)="save()" icon="edit" [loading]="isSavingAccount"></unite-loading-button>
        }
        @if (!account) {
          <unite-loading-button [text]="'Create account'| translate" (click)="add()" icon="add" [loading]="isSavingAccount"></unite-loading-button>
        }
      </mat-dialog-actions>
    </form>
  </div>
}
